import React from "react";

function TabellaDanzaNuova() {
    return(
        <div className="table-container d-flex justify-content-center align-items-center w-100">
            <table className="table m-auto text-center align-middle" style={{width: "70%"}}>
                <colgroup>
                    <col style={{ width: "25%", minWidth: "100px"}} />
                    <col style={{ width: "25%", minWidth: "100px" }} />
                    <col style={{ width: "25%", minWidth: "100px" }} />
                    <col style={{ width: "25%", minWidth: "100px" }} />
                </colgroup>
                <thead>
                <tr>
                    <th className="text-center align-middle" scope="col">Mar</th>
                    <th className="text-center align-middle" scope="col">Mer</th>
                    <th className="text-center align-middle" scope="col">Gio</th>
                    <th className="text-center align-middle" scope="col">Sab</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="text-center align-middle"></td>
                    <td className="text-center align-middle"></td>
                    <td className="text-center align-middle"></td>
                    <td className="text-center align-middle">12:00 - 13:00<br/><strong>Partnering</strong><br/>Adulti</td>
                </tr>
                <tr>
                    <td className="text-center align-middle">15:00 - 16:00<br/><strong>Propedeutica</strong><br/>4-6 anni</td>
                    <td className="text-center align-middle"></td>
                    <td className="text-center align-middle">15:00 - 16:00<br/><strong>Pre Acro</strong><br/>8-11 anni</td>
                    <td className="text-center align-middle"></td>
                </tr>
                <tr>
                    <td className="text-center align-middle">16:00 - 17:00<br/><strong>Danza Classica</strong><br/>6-11 anni</td>
                    <td className="text-center align-middle"></td>
                    <td className="text-center align-middle">16:00 - 17:00<br/><strong>Hip Hop</strong><br/>8-11 anni</td>
                    <td className="text-center align-middle"></td>
                </tr>
                <tr>
                    <td className="text-center align-middle"></td>
                    <td className="text-center align-middle">17:00 - 18:00<br/><strong>Modern Contemporaneo</strong><br/>8-11 anni</td>
                    <td className="text-center align-middle">17:00 - 18:00<br/> <strong>Acro</strong><br/>12-15 anni</td>
                    <td className="text-center align-middle"></td>
                </tr>
                <tr>
                    <td className="text-center align-middle"></td>
                    <td className="text-center align-middle">18:00 - 19:00<br/><strong>Modern Contemporaneo</strong><br/>12-15 anni</td>
                    <td className="text-center align-middle">18:00 - 19:00<br/> <strong>Hip Hop</strong><br/>12-15 anni</td>
                    <td className="text-center align-middle"></td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default TabellaDanzaNuova;